import { RotatingLines } from "react-loader-spinner";
import { DEFAULT_PRIMARY_COLOR, Size } from "../../../constants";
import { useTheme } from "../../../context/theme/useTheme";
import { getWidth } from "./constants";

export const LoadingLines = (props: Props) => {
    const { size, isColorless, colorHex } = props;
    const { isDarkMode } = useTheme();
    const width = getWidth(size);

    return (
        <RotatingLines
            strokeColor={isColorless ? (isDarkMode ? '#4b5563' : '#9ca3af') : colorHex || DEFAULT_PRIMARY_COLOR}
            width={width}
        />
    );
};

type Props = {
    size?: Size;
    isColorless?: boolean;
    colorHex?: string;
};
